import React, { Component } from "react";
import JoditEditor from "jodit-react";
import "./style.css";
export default class RichEditor extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(newContent) {
    this.props.onChange(newContent);
  }

  config = {
    showPlaceholder: true,
    placeholder: this.props.placeholder || "",
    disablePlugins: "add-new-line",
    useSearch: false,
    spellcheck: false,
    enter: "P",
    defaultMode: "1",
    toolbarAdaptive: false,
    toolbarSticky: false,
    showCharsCounter: false,
    showWordsCounter: false,
    showXPathInStatusbar: false,
    minHeight: 350,
    buttons: [
      "bold", "italic", "underline", "strikethrough", "|",
      "superscript", "subscript", "|", "paragraph", "font", "fontsize", "brush", "|",
      "ul", "ol", "outdent", "indent", "|", "align", "|",
      "image", "link", "|", "eraser", "copyformat", "|",
      "selectall", "print", "|", "source", "|", "undo", "redo", "|",
    ],
  };

  render() {
    return (
      <div className="RichEditor">
        <JoditEditor
          value={this.props.value || ""}
          onChange={this.onChange}
          config={this.config}
          className="jodit-editor"
        />
      </div>
    );
  }
}

export function importText(value) {
  return value || "";
}

export function exportText(content) {
  return content;
}
